module.exports = __webpack_public_path__ + "img/1-when-can-i-start-thumbnail - Copy.657e3b66.png";